export interface IZoneDto {
    id?: string;
}
